var render = function render(){var _vm=this,_c=_vm._self._c;return (this.exam.quiztype == 'Random From Question Bank')?_c('div',[_c('RandomExam',{attrs:{"path":this.path}})],1):_c('div',[_c('FixedExam',{attrs:{"path":this.path}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }